var { getSystemObjectTheme } = require('./systemObjectTheme');

// Maps a node icon type to a color family. The actual color values live in
// WorkflowNode.css under `.wf-node-tile-color-<family>` (light + dark variants),
// so dark-mode tints stay readable against the dark canvas.
var TILE_COLOR_FAMILY = {
  start:           'green',
  agent:           'blue',
  'tool-agent':    'blue',
  'computer-use':  'green',
  classifier:      'amber',
  router:          'orange',
  condition:       'amber',
  loop:            'amber',
  sleep:           'amber',
  'file-preview':  'amber',
  'console-log':   'gray',
  'browser-run':   'blue',
  'browser-action': 'blue',
  'browser-agentic-action': 'lavender',
  apify:           'teal',
  variables:       'blue',
  'set-variable':  'teal',
  'flow-ref':      'sky',
  'on-fail':       'pink',

  // Custom user-authored node — quiet slate so the canvas isn't dominated by
  // a sea of bright tiles when most nodes are custom. The inner glyph keeps
  // its purple identity color so a custom node is still recognizable at a glance.
  custom:          'slate',

  webhook:         'pink',
  webhooks:        'pink',
  slack:           'sky',
  discord:         'lavender',
  openai:          'gray',
  'chat-gpt':      'gray',
  'google-drive':  'green',
  gmail:           'pink',
  notion:          'gray',
  github:          'gray'
};

// Returns { family, iconBg, iconColor } for a given icon type.
// `family` is a CSS class suffix; the inner glyph keeps its existing system-object
// colors so node identity stays recognizable in both themes.
function getTileTheme(iconType) {
  var key = String(iconType || '').toLowerCase();
  var family = TILE_COLOR_FAMILY[key] || 'gray';
  var glyph = getSystemObjectTheme(iconType);
  return {
    family: family,
    iconBg: glyph ? glyph.bg : null,
    iconColor: glyph ? glyph.color : null
  };
}

module.exports = {
  getTileTheme: getTileTheme
};
